module.exports = __webpack_public_path__ + "img/content4-4.1fad2e9a.webp";